export default class ClipboardPasteEventHandler {
	constructor() {
		this._onPasteCallbacks = [];
	}

	/**
	 * @param {Element} element
	 */
	init(element) {
		element.addEventListener('paste', (evt) => {
			evt.preventDefault();
			const clipboardText = (evt.clipboardData || window.clipboardData).getData('text');
			for (const onPasteCallback of this._onPasteCallbacks)
				onPasteCallback(clipboardText);
		});
	}

	onPaste(cb) {
		this._onPasteCallbacks.push(cb);
	}
}
